<template>
  <div>
    <modal :show.sync="editModal" header-classes="bg-primary p-7" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold"
      >
        Caregiver Saathi
      </h6>
      <div class="mt-5">
        <p class="mt-2 input-title-black">By submitting this form:</p>
        <p class="mt-2 input-title-black">
          1) You let Caregiver Saathi and its partners use this data for
          insights and analytics. You are not flooded with unnecessary
          information, and it enables us to send you more relevant information
          and resources to support you.
        </p>
        <p class="mt-2 input-title-black">
          2) You agree to be contacted with information and future programs,
          events,promotions, pertaining to the areas of interest you have
          specified in this form.
        </p>
      </div>
      <template slot="footer">
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(handleSend)">
        <div class="flex justify-between">
          <p class="font-bold text-white fsize35-20 lg:mb-2 md:mb-2">
            Request For Services
          </p>
        </div>
        <div class="lg:pt-6 md:pt-6 lg:flex md:flex gap-x-5 gap-y-2">
          <div class="lg:w-1/2 md:w-1/2">
            <p class="input-title">Patient's Name</p>
            <base-input
              v-model="patientname"
              placeholder="Enter Patient's name"
              class="md:border-0 lg:border-0"
              name="Name"
              :rules="{ required: true }"
            ></base-input>
          </div>

          <div class="lg:w-1/2 md:w-1/2">
            <p class="input-title">Patient's Age</p>
            <base-input
              v-model="patientage"
              placeholder="Enter Patient's Age"
              class="md:border-0 lg:border-0"
              name="Age"
              :rules="{ required: true }"
            ></base-input>
          </div>
        </div>

        <!-- <div>
          <p class="input-title">Which services are you interested in</p>
          <multiselect
            class="mb-6 cust-hScroller"
            v-model="value"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder=""
            label="name"
            track-by="name"
            :preselect-first="true"
          >
          </multiselect>
        </div> -->
        <div class="">
          <p class="input-title">
            Please tell us in brief about the medical condition
          </p>

          <b-form-textarea
            id="textarea"
            v-model="medicalcondition"
            placeholder="Enter Medical Condition..."
            rows="3"
            max-rows="6"
            class="scrollnone"
            name="Report"
            :state="medicalcondition.length >= 1"
          ></b-form-textarea>
        </div>
        <div class="">
          <p class="input-title lg:mt-4 md:mt-4 mt-4">
            Additional comments if any
          </p>

          <b-form-textarea
            id="textarea"
            v-model="comment"
            placeholder="Enter something..."
            rows="3"
            max-rows="6"
            class="scrollnone"
          ></b-form-textarea>
        </div>
        <div class="md:mt-6 mt-6 lg:mt-8 mb-12 bottom6-4 w-full">
          <b-form-checkbox
            id="checkbox-1"
            value=" I have read and agreed to these"
            unchecked-value="I have read and agreed to these"
            v-model="status"
          >
            <p>
              <strong class="text-white"
                >{{ status }}
                <u class="ublue" @click="editModal = true"
                  >terms and conditions</u
                ></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="md:mt-6 mt-6 lg:mt-8 mb-12 bottom6-4 w-full">
          <b-button
            type="submit"
            variant="secondary"
            :disabled="isdisabled"
            class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 border-2 text-base font-bold"
            >Submit</b-button
          >
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import emailMixin from "@/mixins/email";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      select1Normal: "",
      select1: [],
      select2: [],
      name: "",
      selected: null,
      relation: "",
      email: "",
      mobile: "",
      location: "",
      patientname: "",
      patientage: "",
      serviceintrested: [],
      medicalcondition: "",
      comment: "",
      servicearrr: [],
      options: [],
      arrayservice: "",
      value: [],
      status: "I have read and agreed to these",
      editModal: false,
    };
  },
  components: {
    Multiselect,
  },
  mixins: [emailMixin],

  methods: {
    async handleSend() {
      this.value.forEach((x) => {
        this.servicearrr.push(x.name);
      });

      const payload = {
        patientname: this.patientname,
        patientage: this.patientage,
        serviceintrested: this.value,
        medicalcondition: this.medicalcondition,
        comment: this.comment,
        privacypolicy: this.status,
        ...this.setreg,
      };
      // console.log(this.payload);
      // console.log(this.value);

      await this.$store.dispatch("services/createregform", payload);
      const to = ["services@caregiversaathi.co.in"];
      const bcc = [
        "yash.singh@aiab.in",
        "bhavana.issar@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];

      const subject = "Requested Services";
      const body = `
      Name: ${this.setreg.name}<br />
      Email Address: ${this.setreg.email}<br />
      Mobile No.: ${this.setreg.mobile}<br />
      City: ${this.setreg.location}<br />
      Relation: ${this.setreg.relation}<br />
      Patient Name: ${this.patientname}<br />
      Patient Age: ${this.patientage}<br />
      Service Intrested: ${this.servicearrr.toString()}<br />
      Medical Condition: ${this.medicalcondition}<br />
      Additional Comment: ${this.comment}<br />
      `;
      await this.sendEmail(to, subject, body, bcc);
      this.$swal.fire({
        // title: "Created",
        text: "Thank you for submitting your details. We value your need. Allow our team 24-48 hours to get back to you.",
        icon: "success",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });
      // this.$refs.formValidator.reset();
    },
  },
  mounted() {
    this.$store.dispatch("services/getpartner");
    // console.log(this.get_AllPartner);
    // console.log(this.setreg);
    // console.log(this.value.name);
    this.get_AllPartner.forEach((x) => {
      const array = this.options.push({
        name: x.title,
      });
    });
  },
  computed: {
    ...mapState("services", { get_AllPartner: "get_AllPartner" }),
    ...mapState("services", { setreg: "setreg" }),

    isValidForm() {
      if (this.otp == "") {
        return true;
      } else if (this.name != "") {
        return false;
      } else {
        return true;
      }
    },
    isdisabled() {
      if (this.status == "I have read and agreed to these") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.ublue {
  color: rgb(86, 86, 248);
}
</style>
